import { EventHandler } from '@ui-common/types'
import { JSX, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const RemainingTime = styled.span``

interface CountdownTimerProps {
  initialTimeInSeconds: number
  onComplete: EventHandler
}

export const CountdownTimer = ({ initialTimeInSeconds, onComplete }: CountdownTimerProps): JSX.Element => {
  const { formatMessage } = useIntl()
  const [currentTime, setCurrentTime] = useState(initialTimeInSeconds - 1)
  const minutes = Math.floor(currentTime / 60)
  const seconds = currentTime % 60
  const remainingTime =
    minutes < 1
      ? formatMessage({ id: 'common-logout-in-seconds' }, { numOfSeconds: seconds >= 0 ? seconds : 0 })
      : formatMessage({ id: 'common-logout-in-minutes' }, { numOfMinutes: minutes + 1 })

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (currentTime <= 0) {
        clearInterval(timerInterval)
        onComplete()
      } else {
        setCurrentTime(currentTime - 1)
      }
    }, 1000)

    return () => {
      clearInterval(timerInterval)
    }
  }, [currentTime, onComplete])

  return <RemainingTime>{remainingTime}</RemainingTime>
}
